import React from "react";
import { Button, Grid2 as Grid, Grid2Props, IconButton } from "@mui/material";
import { singleGridItem } from "../fields/defaultStyles";
import ReferencesList from "./ReferencesList";
import ArraySubFormProvider from "../fields/subForms/array/ArraySubFormProvider";
import ArraySubFormList from "../fields/subForms/array/ArraySubFormList";
import { FormRichTextField } from "../fields/basic/RichTextField";
import { useFormHandlerContext } from "../../../controllers/formController";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import ArraySubFormAdd from "../fields/subForms/array/ArraySubFormAdd";
import GroupGridContainer from "../../common/GroupGridContainer";

interface AttributeMetadataItemsProps extends Grid2Props {
  name: string;
  disabled?: boolean;
}

const AttributeMetadataItems: React.FC<AttributeMetadataItemsProps> = ({
  name,
  disabled = false,
  ...grid
}) => {
  const { isProcessing } = useFormHandlerContext();

  return (
    <Grid container spacing={1} {...singleGridItem} {...grid}>
      <ArraySubFormProvider name={name}>
        <ArraySubFormList
          renderItem={(_, remove) => (
            <GroupGridContainer>
              <FormRichTextField
                name="notes"
                label="Notes"
                disabled={disabled || isProcessing}
                labelActions={
                  <IconButton
                    color="error"
                    onClick={() => remove()}
                    size="small"
                    disabled={disabled || isProcessing}
                  >
                    <RemoveCircleOutline />
                  </IconButton>
                }
                placeholder="Enter notes"
              />
              <ReferencesList
                label="References"
                name="references"
                rowLabel="Reference"
                disabled={disabled || isProcessing}
                placeHolder={(index) => `Reference ${index + 1}`}
              />
            </GroupGridContainer>
          )}
        />
        <Grid {...singleGridItem}>
          <ArraySubFormAdd
            render={(append) => (
              <Button
                variant="contained"
                fullWidth
                color="primary"
                startIcon={<AddCircleOutline />}
                disabled={disabled || isProcessing}
                onClick={() => append({ notes: "", references: [] })}
              >
                Add Item
              </Button>
            )}
          />
        </Grid>
      </ArraySubFormProvider>
    </Grid>
  );
};

export default AttributeMetadataItems;
